<template>
  <div class="matrix_layoutMain container" :class="getClassNameContainer">
    <div class="row">
      <div class="col-md-12">
        <appQuantitySelectionContainer></appQuantitySelectionContainer>
        <appCostCenter></appCostCenter>
        <appAddToCartButton></appAddToCartButton>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";

export default {};
</script>
